import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse, Fee } from 'types';

const useFee = ({
  queries,
  enabled,
}: {
  queries: {
    transaction_method: string;
    currency: string;
  };
  enabled?: boolean;
}): UseQueryResult<Fee, ErrorResponse> => {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }

  return useQuery([`${url.fee}${queryParams}`], {
    enabled: enabled,
  });
};
export default useFee;
